// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4.25 11.75H3.5C2.4 11.75 1.5 10.85 1.5 9.75V7.5C1.5 6.4 2.4 5.5 3.5 5.5H12.5C13.6 5.5 14.5 6.4 14.5 7.5V9.75C14.5 10.85 13.6 11.75 12.5 11.75H11.75',
  'M4.25 5.5V2.75C4.25 2.06 4.81 1.5 5.5 1.5H10.5C11.19 1.5 11.75 2.06 11.75 2.75V5.5',
  'M5.25 9H10.75C11.3 9 11.75 9.45 11.75 10V13.5C11.75 14.05 11.3 14.5 10.75 14.5H5.25C4.7 14.5 4.25 14.05 4.25 13.5V10C4.25 9.45 4.7 9 5.25 9Z',
];
